"use client";
import { WithMobile } from "@/lib/isMobile";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { CSSProperties } from "react";

interface Props {
  descInfo: {
    title: string;
    desc: string;
    img: string;
  };
  deviceType?: {
    isMobile: boolean;
    isPad: boolean;
  };
}

function FrameworkEle({ descInfo, deviceType }: Props) {
  return (
    <section className="bg-[#fafcfe]">
      <div
        className="container flex items-center justify-between flex-col md:flex-row
        py-0 md:py-14"
      >
        <div
          className="space-y-8 font-normal text-[#333333] flex flex-col
          items-center md:items-start
          pt-0 pb-0 md:pt-16 md:pb-20
          w-full md:w-[31rem] 
          px-6 md:px-0
          "
        >
          <h4 className="text-xl md:text-3xl">方案简介</h4>
          {/* <h4 className="text-xl">{descInfo.title}</h4> */}
          <p className="text-sm md:text-base leading-7 overflow-hidden text-ellipsis line-clamp-6">
            {descInfo.desc}
          </p>
        </div>
        <Image
          src={descInfo.img}
          alt={descInfo.title}
          quality={100}
          /* width={descInfo.width}
          height={descInfo.height}
          style={descInfo.style} */
          width={1280}
          height={720}
          style={{ width: "640px", height: "100%" }}
        />
      </div>
    </section>
  );
}

export default WithMobile(FrameworkEle);
